import * as getters from "../../baseQuestion/file/store/getters";
import * as mutations from "../../baseQuestion/file/store/mutations";
import * as actions from "../../baseQuestion/file/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/file/store/state";

function state() {
	return Object.assign(
		{
			accepted_file_types:
				"text/plain, application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
